import React, {useState} from 'react';
import {Link} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Box, IconButton, ListItem, ListItemText} from '@mui/material';
import useStoredRouteUpdate from "../../hooks/useStoredRouteUpdate";
import {MuiButton} from "../MuiButton";
import {getUrl, PWAUrls} from "../../config/urls";
import {getCliffTypeFromLocale, getMultipitchTypeFromLocale, getStoreRouteCacheTime} from "../../utils/helpers";
import Constants from "../../config/constants";
import {getRouteUrl, useRoute} from "../../hooks/useRoute";
import RouteAvatar from "../Route/SearchComponent/RouteAvatar";

const SaveRouteListItemComponent = ({i18n, t, saveRoute,  onClose, user, isOnline}) => {
    const url = getRouteUrl(saveRoute.type, i18n.language, saveRoute.route.slug);
    const { status, data: fullRoute } = useRoute(url, saveRoute.route.slug, user);
    const cacheTime = getStoreRouteCacheTime(saveRoute.endValidationDate);
    const {mutateAsync, status: mutateStatus, error: error } = useStoredRouteUpdate(i18n.language);
    const removeCustomerRoute = async (id) => {
        await mutateAsync({
            id: id,
            action: 'remove',
        });
    }

    let link;
    if (saveRoute.type === Constants.CLIFF) {
        link = getUrl(PWAUrls.SECTOR_ROUTE, {lng: i18n.language, routeType: getCliffTypeFromLocale(i18n.language), slugRegion: saveRoute.route.region.slug, slugGroupRoute: saveRoute.route.cliff.slug, slug: saveRoute.route.slug});
    } else {
        link = getUrl(PWAUrls.MULTIPITCH_ROUTE, {lng: i18n.language, routeType: getMultipitchTypeFromLocale(i18n.language), slugRegion: saveRoute.route.region.slug, slug: saveRoute.route.slug});
    }

    const [askDelete, setAskDelete] = useState(false);

    return (
        <ListItem
            secondaryAction={<>
                <Box display="flex" alignItems="center">
                    {(mutateStatus === "success" || mutateStatus === "idle") && !askDelete && isOnline && <IconButton edge="end" aria-label="delete" onClick={() => setAskDelete(true)}>
                        <FontAwesomeIcon icon={["fas", "trash"]} size="sm" className="primary" />
                    </IconButton>}
                    {(mutateStatus === "success" || mutateStatus === "idle") && askDelete && <>

                    </>}
                    {mutateStatus === "pending" && <IconButton edge="end" aria-label="loading">
                        <FontAwesomeIcon icon={["fas", "spinner"]} size="sm" spin className="secondary" />
                    </IconButton>}
                    {mutateStatus === "error" && <IconButton edge="end" aria-label="error">
                        <FontAwesomeIcon icon={["fas", "exclamation-triangle"]} size="sm" className={"text-danger"} />
                    </IconButton>}
                </Box>
            </>}
        >
            <ListItemText
                primary={<Link to={link} onClick={() => {onClose(false);}}>
                            <Box display="flex" alignItems="center">
                                {fullRoute?.id && <Box sx={{mr:1}}>
                                    <RouteAvatar
                                        item={fullRoute} />
                                </Box>}
                                <Box flexGrow={1}>
                                    {saveRoute.label}
                                </Box>
                            </Box>
                        </Link>}
                secondary={<>
                    {cacheTime <= 0 && <label className={"text-danger my-1"}>{t("Navbar.saveRoute.activationOver")}</label>}
                    {askDelete ? <>{cacheTime <= 0 && <br/>}

                            <Box display="flex" alignItems="flex-start" style={{textAlign: "center"}}>
                                <label className={"my-2"}>{t("Navbar.saveRoute.delete.confirm")}</label>
                            </Box>
                            <Box display="flex" alignItems="flex-start" style={{textAlign: "left"}}>
                                <Box flexGrow={1}>
                                    <MuiButton variant="outlined"
                                               color="primary"
                                               edge="start"
                                               aria-label="delete"
                                               onClick={(e) => {e.preventDefault(); setAskDelete(false)}}>
                                        {t("common.cancel")}
                                        {/*<FontAwesomeIcon icon={["fas", "times"]} size="sm" />*/}
                                    </MuiButton>
                                </Box>
                                <Box flexGrow={1}>
                                    <MuiButton variant="contained" color="primary" edge="end" aria-label="delete" onClick={(e) => {e.preventDefault(); removeCustomerRoute(saveRoute.route.id)}}>
                                        {t("common.confirm")}
                                        {/*<FontAwesomeIcon icon={["fas", "check"]} size="sm" />*/}
                                    </MuiButton>
                                </Box>
                            </Box>
                        </>
                        : null }
                </>}
                          />

        </ListItem>
    );
};

export default withTranslation()(SaveRouteListItemComponent);